module.exports = __webpack_public_path__ + "static/media/flashlogo.23ddf72f.png";